import { useState } from 'react';
import './App';

function Browser() {
  return (
    <div className="App">

    </div>
  );
}

export default Browser;
